import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ContentWrapper from "../Common/Containers/ContentContainer";
import Tab from "../Common/Tab";
import BeneficiarySettings from "./Beneficiaries/BeneficiarySettings";
import ContributionSettings from "./Contributions/ContributionsSettings";
import GoalSettings from "./Goals/GoalSettings";

const Settings: React.FC = () => {
  const { t } = useTranslation();

  enum TabName {
    Beneficiaries = "Beneficiaries",
    Goals = "Goals",
    Contributions = "Contributions",
  }

  const tabs = [
    {
      key: TabName.Beneficiaries,
      label: t("savings_settings.tabs.beneficiaries"),
    },
    { key: TabName.Goals, label: t("savings_settings.tabs.goals") },
    {
      key: TabName.Contributions,
      label: t("savings_settings.tabs.contributions"),
    },
  ];

  const [activeTab, setActiveTab] = useState<TabName>(TabName.Beneficiaries);

  const handleTabClick = (tab: TabName) => {
    setActiveTab(tab);
  };

  const renderActiveComponent = () => {
    switch (activeTab) {
      case TabName.Beneficiaries:
        return <BeneficiarySettings />;

      case TabName.Goals:
        return <GoalSettings />;

      case TabName.Contributions:
        return <ContributionSettings />;

      default:
        return <BeneficiarySettings />;
    }
  };

  return (
    <ContentWrapper>
      <div className="w-full m-auto bg-white font-outfit">
        <div className="w-full md:w-[664px] flex justify-center md:justify-start mx-auto space-x-2 py-[18px] items-center">
          {tabs.map((tab) => (
            <Tab
              key={tab.key}
              label={tab.label}
              isActive={activeTab === tab.key}
              onClick={() => handleTabClick(tab.key)}
            />
          ))}
        </div>
      </div>

      <div
        // className="min-h-[50vh] bg-gradient-to-b from-custom-blue to-custom-purple py-10 font-outfit"
        className="min-h-[50vh]  py-10 font-outfit"
      >
        <div className="w-full md:w-[664px] mx-auto px-4">
          <div className="shadow-introBox font-outfit bg-white rounded-[16px]">
            {renderActiveComponent()}
          </div>
        </div>
      </div>
    </ContentWrapper>
  );
};

export default Settings;
